export default __webpack_public_path__ + "static/media/boy3.c8e44bab.svg";